import {
  NEW_INTEGRATION_SAT_DATA,
  NEW_INTEGRATION_SAT_DOWNLOADS,
  NEW_INTEGRATION_SAT_ERRORS,
  NEW_INTEGRATIONS_STATE,
  NEW_SPEI_DATA,
  UPDATE_INTEGRATION
} from '../actions/integrationsActions';

import {
  RESET_ACCOUNT,
  LOG_OUT
} from '../actions/accountActions';

const initialState = {
  sat: null,
  sat_downloads: null,
  spei: null,
  states: null,
  satErrors: null,
  contpaqi: null,
};

export default function (state = initialState, action) {
  let { payload, type } = action, newState;
  switch (type) {

    case NEW_INTEGRATIONS_STATE:
      newState = { ...state, ...payload };
      return { ...state, ...newState };

    case NEW_INTEGRATION_SAT_DATA:
      newState = { sat: payload };
      return { ...state, ...newState };

    case NEW_INTEGRATION_SAT_DOWNLOADS:
      newState = { sat_downloads: payload };
      return { ...state, ...newState };

    case NEW_INTEGRATION_SAT_ERRORS:
      newState = { satErrors: payload };
      return { ...state, ...newState };

    case NEW_SPEI_DATA:
      newState = { spei: payload };
      return { ...state, ...newState };

    case UPDATE_INTEGRATION:
      newState = { [payload.integration]: { ...state[payload.integration], ...payload.newAttributes } };
      return { ...state, ...newState };

    case RESET_ACCOUNT:
    case LOG_OUT:
      return { ...initialState };

    default:
      return state;

  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/integrationsReducer.js